import axios from 'axios'

export default (function () {
    return axios.create({
        baseURL: process.env.RESOURCE ? process.env.RESOURCE + 'api/' : 'http://nl.coder:c0d3r@stwv-crowdfunding.dev.netzlabor-coding.de/api/',
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://stwv-crowdfunding.dev.netzlabor-coding.de/api/',
        // auth: {
        //     username: 'nl.coder',
        //     password: 'c0d3r'
        // },
        transformResponse: [function (data) {
            // Parse JSON rsponse
            const parsedJson = JSON.parse(data)
            // check if we have a data key
            if (parsedJson.data) {
                return parsedJson.data
            }
            // return data.data to get rid of double data in access path
            return parsedJson
        }]
    })
})()



// WEBPACK FOOTER //
// ./src/resources/index.js